import React, { useEffect, useState, useRef } from 'react';
import {
  Html5Qrcode,
  Html5QrcodeSupportedFormats
} from 'html5-qrcode';

import Footer from '../layout/footer/footer';

import BannerImg from '../assets/images/banner2.png';
import GiftImg from "../assets/icons/gift.svg";
import ArrowCurve from "../assets/images/arrow-curve.svg";
import Phone from "../assets/images/phone.svg";
import Idea from "../assets/images/idea.svg";
import Money from "../assets/images/money.svg";
import Design from "../assets/images/featur-design.svg";
import DesignThink from "../assets/images/design-think.svg";
import LogoBeard from "../assets/images/logo-beard2.svg";
import Dots from "../assets/images/dots.svg";
import ThreeDots from "../assets/images/tree-dot.svg";
import Basket from '../assets/icons/basket.svg';
import SDots from '../assets/images/dots/s-dots.svg';


// feature
import Technical from '../assets/images/features/technical.png';
import ShoppingCart from '../assets/images/features/shopping-cart.png';
import Picture from '../assets/images/features/picture.png';
import OfficeBuilding from '../assets/images/features/office-building.png';
import Illustration from '../assets/images/features/illustration.png';
import Deadline from '../assets/images/features/deadline.png';
import Acceptance from '../assets/images/features/acceptance.png';

// category
import buy from '../assets/images/categories/buy.png';
import charge from '../assets/images/categories/charge.png';
import orgPack from '../assets/images/categories/orgpack.png';

import Birthday from '../assets/images/categories/birthday.png';
import Married from '../assets/images/categories/married.png';
import Ect from '../assets/images/categories/ect.png';
import Special from '../assets/images/categories/special.png';
import Parents from '../assets/images/categories/parents.png';

// slider
import homeslider1 from '../assets/images/slider/homeSlider1.png';
import homeslider1mobile from '../assets/images/slider/homeSilder1Mobile.png';
import homeslider2 from '../assets/images/slider/homeSlider2.jpg';
import homeslider2mobile from '../assets/images/slider/homeSilder2Mobile.jpg';

import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Navigation,
  Pagination,
  Autoplay
} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import CashlessPayment from '../assets/images/features/cashless-payment.png';
import CustomerComponent from '../components/customer-list/customerList';
import DesignCard from "../assets/images/design-card.png";
import ProductItems from "../components/productsItem/products-items";

import './home.css';

import DesignEditor from '../components/design/component-design';

import {
  useLocation,
  Link,
  useNavigate
} from 'react-router-dom';

import { Sidebar } from 'primereact/sidebar';
import ArrowDown from '../assets/icons/select-arrow-down.svg';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

import Select, {
  components
} from 'react-select';

// API
import {
  getCategories,
  getSettings,
  getHomeSliders,
  imgBaseUrl
} from '../utils/api';

import {
  Accordion,
  Col,
  Form,
  InputGroup
} from 'react-bootstrap';

import Editor from './image/editor';
import FaqAccordion from './faq/faq-accordion';
import useToastNotification from '../hooks/useToastNotification';


function Home() {

  const navigate = useNavigate();

  const [category, setCategory] = useState(0);

  const [pageLoading, setPageLoading] = useState(true);

  const [categoryitem, setCategoryItem] = useState({
    id: 0,
    title: ""
  });

  const [categoryList, setCategoryList] = useState([]);

  const [visibleCategory, setVisibleCategory] = useState(false);

  const [sliderCategories, setSliderCategories] = useState([]);

  const [homeSliders, setHomeSliders] = useState([]);

  const toast = useRef(null);

  const {
    showError,
    showSuccess
  } = useToastNotification();


  // =========================================================
  // Card services
  // =========================================================

  const CARD_PREFIX_1 = '6221';
  const CARD_PREFIX_2 = '0620';

  const [cardServicesOpen, setCardServicesOpen] = useState(false);

  const [cardPart3, setCardPart3] = useState('');
  const [cardPart4, setCardPart4] = useState('');

  const cardPart3Ref = useRef(null);
  const cardPart4Ref = useRef(null);


  // =========================================================
  // QR Scanner
  // =========================================================

  const qrScannerRef = useRef(null);

  const qrScannerRunningRef = useRef(false);

  const qrScannerStoppingRef = useRef(false);

  const qrScanResolvedRef = useRef(false);

  const lastQrTextRef = useRef('');

  const [qrScannerOpen, setQrScannerOpen] = useState(false);

  const [qrScannerStarting, setQrScannerStarting] = useState(false);


  // تبدیل اعداد فارسی و عربی به انگلیسی
  const normalizeNumerals = (value = '') =>
    String(value)
      .replace(
        /[۰-۹]/g,
        (digit) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)
      )
      .replace(
        /[٠-٩]/g,
        (digit) => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit)
      );


  const normalizeCardDigits = (value = '') =>
    normalizeNumerals(value)
      .replace(/\D/g, '')
      .slice(0, 4);


  const handleCardPartChange = (
    value,
    setter,
    nextRef
  ) => {

    const digits = normalizeCardDigits(value);

    setter(digits);

    if (digits.length === 4) {
      nextRef?.current?.focus();
    }
  };


  const cardNumber =
    `${CARD_PREFIX_1}${CARD_PREFIX_2}${cardPart3}${cardPart4}`;


  const isCardNumberComplete =
    /^\d{16}$/.test(cardNumber);


  const goToCardServices = () => {

    if (!isCardNumberComplete) {
      return;
    }

    navigate(`/cardService/${cardNumber}`);
  };


  // =========================================================
  // Extract card number from QR
  // =========================================================

  const extractCardNumberFromQrText = (value = '') => {

    const normalizedText =
      normalizeNumerals(value);

    /*
      کارت باید با:
      62210620
      شروع شود و بعد از آن 8 رقم دیگر داشته باشد.
    */

    const match =
      normalizedText.match(
        /62210620\d{8}(?!\d)/
      );

    return match ? match[0] : '';
  };


  // =========================================================
  // Optimize camera after start
  // =========================================================

  const optimizeRunningCamera = async (scanner) => {

    if (!scanner) {
      return;
    }

    try {

      const capabilities =
        scanner.getRunningTrackCapabilities?.();

      const constraints = {
        width: {
          ideal: 1920
        },

        height: {
          ideal: 1080
        }
      };


      /*
        در دوربین‌هایی که continuous autofocus دارند
        فوکوس پیوسته فعال می‌شود.
      */

      if (
        capabilities &&
        Array.isArray(capabilities.focusMode) &&
        capabilities.focusMode.includes('continuous')
      ) {

        constraints.advanced = [
          {
            focusMode: 'continuous'
          }
        ];
      }


      await scanner.applyVideoConstraints(
        constraints
      );

    } catch (error) {

      /*
        همه موبایل‌ها و مرورگرها این قابلیت را ندارند.
        نبودن آن باعث توقف QR Scanner نمی‌شود.
      */

      console.warn(
        'Camera optimization is not supported on this device:',
        error
      );
    }
  };


  // =========================================================
  // Stop QR scanner
  // =========================================================

  const stopQrScanner = async () => {

    const scanner =
      qrScannerRef.current;


    if (
      !scanner ||
      qrScannerStoppingRef.current
    ) {
      return;
    }


    qrScannerStoppingRef.current = true;


    try {

      if (qrScannerRunningRef.current) {

        await scanner.stop();

      }

    } catch (error) {

      console.warn(
        'Unable to stop QR scanner cleanly:',
        error
      );

    }


    try {

      scanner.clear();

    } catch (error) {

      console.warn(
        'Unable to clear QR scanner:',
        error
      );

    }


    if (qrScannerRef.current === scanner) {
      qrScannerRef.current = null;
    }


    qrScannerRunningRef.current = false;

    qrScannerStoppingRef.current = false;
  };


  // =========================================================
  // Close QR scanner
  // =========================================================

  const closeQrScanner = async () => {

    qrScanResolvedRef.current = false;

    lastQrTextRef.current = '';

    await stopQrScanner();

    setQrScannerOpen(false);

    setQrScannerStarting(false);
  };


  // =========================================================
  // QR Scanner Effect
  // =========================================================

  useEffect(() => {

    if (!qrScannerOpen) {
      return undefined;
    }


    let cancelled = false;


    // -----------------------------------------
    // Successful QR decode
    // -----------------------------------------

    const handleScanSuccess = async (
      decodedText
    ) => {

      if (
        cancelled ||
        qrScanResolvedRef.current
      ) {
        return;
      }


      const scannedCardNumber =
        extractCardNumberFromQrText(
          decodedText
        );


      if (scannedCardNumber) {

        /*
          مهم:
          جلوگیری از اجرای چندباره callback
          هنگام تشخیص QR در چند frame متوالی
        */

        qrScanResolvedRef.current = true;


        setCardPart3(
          scannedCardNumber.slice(8, 12)
        );


        setCardPart4(
          scannedCardNumber.slice(12, 16)
        );


        await stopQrScanner();


        if (!cancelled) {

          setQrScannerOpen(false);

          setQrScannerStarting(false);

          navigate(
            `/cardService/${scannedCardNumber}`
          );
        }


        return;
      }


      /*
        اگر QR خوانده شده باشد،
        ولی شماره کارت معتبر داخلش نباشد،
        برای هر frame مجدداً Toast نشان نمی‌دهیم.
      */

      if (
        decodedText &&
        decodedText !== lastQrTextRef.current
      ) {

        lastQrTextRef.current =
          decodedText;


        showError(
          'رمزینه (QR-Code) خوانده شد، اما شماره کارت معتبر داخل آن پیدا نشد.'
        );
      }
    };


    // -----------------------------------------
    // Start scanner
    // -----------------------------------------

    const startQrScanner = async () => {

      try {

        lastQrTextRef.current = '';

        qrScanResolvedRef.current = false;

        setQrScannerStarting(true);


        // HTTPS check
        if (
          !window.isSecureContext &&
          window.location.hostname !== 'localhost'
        ) {

          throw new Error(
            'INSECURE_CONTEXT'
          );
        }


        // Camera support check
        if (
          !navigator.mediaDevices?.getUserMedia
        ) {

          throw new Error(
            'CAMERA_NOT_SUPPORTED'
          );
        }


        /*
          مهم‌ترین تغییر:

          BarcodeDetector مرورگر دیگر خاموش نیست.

          اگر مرورگر از BarcodeDetector پشتیبانی کند،
          html5-qrcode می‌تواند از decoder سریع‌تر مرورگر استفاده کند.
        */

        const scanner =
          new Html5Qrcode(
            'card-qr-reader',
            {
              formatsToSupport: [
                Html5QrcodeSupportedFormats.QR_CODE
              ],

              useBarCodeDetectorIfSupported: true,

              verbose: false
            }
          );


        qrScannerRef.current =
          scanner;


        /*
          fps از 10 به 20 افزایش یافته.

          qrbox هم بزرگ‌تر شده تا QR مجبور نباشد
          خیلی به دوربین نزدیک شود.
        */

        const config = {

          fps: 20,


          qrbox: (
            viewfinderWidth,
            viewfinderHeight
          ) => {

            const minEdge =
              Math.min(
                viewfinderWidth,
                viewfinderHeight
              );


            /*
              85 درصد کوچک‌ترین ضلع تصویر

              قبلاً 72 درصد بود.
              اکنون QR از فاصله بیشتری می‌تواند
              داخل منطقه اسکن قرار بگیرد.
            */

            const size =
              Math.floor(
                minEdge * 0.85
              );


            return {
              width: size,
              height: size
            };
          },


          /*
            چون از دوربین پشت استفاده می‌کنیم
            نیازی به Mirror / Flip نیست.
          */

          disableFlip: true
        };


        /*
          frameهایی که QR در آن‌ها تشخیص داده نمی‌شود
          خطای واقعی نیستند.
        */

        const onScanFailure = () => {
          // intentionally ignored
        };


        try {

          /*
            ابتدا مستقیم دوربین پشت درخواست می‌شود.
          */

          await scanner.start(
            {
              facingMode: {
                ideal: 'environment'
              }
            },
            config,
            handleScanSuccess,
            onScanFailure
          );


        } catch (primaryCameraError) {

          const errorText =
            String(primaryCameraError);


          const permissionDenied =
            primaryCameraError?.name ===
              'NotAllowedError' ||

            errorText.includes(
              'Permission'
            ) ||

            errorText.includes(
              'NotAllowedError'
            );


          if (permissionDenied) {

            throw primaryCameraError;

          }


          /*
            fallback:
            اگر مرورگر facingMode را درست تشخیص نداد،
            لیست دوربین‌ها گرفته می‌شود.
          */

          const cameras =
            await Html5Qrcode.getCameras();


          if (!cameras?.length) {

            throw primaryCameraError;

          }


          /*
            ترجیح:
            back
            rear
            environment

            در غیر این صورت آخرین دوربین دستگاه.
          */

          const preferredCamera =
            cameras.find(
              (camera) =>
                /back|rear|environment/i.test(
                  camera.label || ''
                )
            ) ||

            cameras[
              cameras.length - 1
            ];


          await scanner.start(
            preferredCamera.id,
            config,
            handleScanSuccess,
            onScanFailure
          );
        }


        /*
          از اینجا دوربین فعال است.
        */

        qrScannerRunningRef.current =
          true;


        /*
          فعال کردن رزولوشن بهتر و continuous autofocus
          در دستگاه‌هایی که پشتیبانی می‌کنند.
        */

        await optimizeRunningCamera(
          scanner
        );


        /*
          ممکن است component هنگام start شدن
          unmount شده باشد.
        */

        if (cancelled) {

          await stopQrScanner();

          return;
        }


        setQrScannerStarting(false);


      } catch (error) {

        console.error(
          'Unable to start QR scanner:',
          error
        );


        await stopQrScanner();


        if (cancelled) {
          return;
        }


        setQrScannerStarting(false);

        setQrScannerOpen(false);


        // -----------------------------------------
        // Error messages
        // -----------------------------------------

        if (
          error?.message ===
          'INSECURE_CONTEXT'
        ) {

          showError(
            'برای دسترسی به دوربین، سایت باید با HTTPS باز شود.'
          );

        }

        else if (
          error?.name ===
            'NotAllowedError' ||

          String(error).includes(
            'Permission'
          )
        ) {

          showError(
            'برای اسکن رمزینه (QR-Code) باید اجازه دسترسی به دوربین را بدهید.'
          );

        }

        else if (
          error?.name ===
            'NotFoundError' ||

          String(error).includes(
            'Requested device not found'
          )
        ) {

          showError(
            'دوربین قابل استفاده روی این دستگاه پیدا نشد.'
          );

        }

        else if (
          error?.message ===
          'CAMERA_NOT_SUPPORTED'
        ) {

          showError(
            'مرورگر این دستگاه امکان دسترسی به دوربین را ندارد.'
          );

        }

        else {

          showError(
            'امکان فعال‌کردن دوربین برای اسکن رمزینه (QR-Code) وجود ندارد. لطفاً دسترسی دوربین مرورگر را بررسی کنید.'
          );

        }
      }
    };


    /*
      یک render صبر می‌کنیم
      تا #card-qr-reader در DOM ساخته شود.
    */

    const timer =
      window.setTimeout(
        startQrScanner,
        0
      );


    return () => {

      cancelled = true;

      window.clearTimeout(timer);

      stopQrScanner();

    };

  }, [
    qrScannerOpen,
    navigate
  ]);


  // =========================================================
  // Editor
  // =========================================================

  const [text, setText] = useState('');

  const [color, setColor] = useState('');

  const [font, setFont] = useState('');

  const [fonts, setFonts] = useState([
    'shabnam-medium',
    'IRANSans',
    'iran-yekan-medium',
  ]);

  const [size, setSize] =
    useState('16');

  const [sizes, setSizes] =
    useState([
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
    ]);


  const [image, setImage] =
    useState(null);


  const selectImage = (e) => {

    if (e.target.files[0]) {

      setImage(
        e.target.files[0]
      );
    }


    let element =
      document.getElementById(
        'choose-file'
      );


    if (element) {

      element.value = null;

    }
  };


  const resetImage = () => {

    setImage(null);

  };


  const getSettingsfun =
    async () => {

      try {

        let setting =
          await getSettings();


        setPageLoading(false);


        localStorage.setItem(
          'settings',
          JSON.stringify(
            setting.data.data
          )
        );

      } catch (error) {

        setPageLoading(false);

      }
    };


  useEffect(() => {

    setTimeout(() => {

      let cat =
        JSON.parse(
          sessionStorage.getItem(
            'categories'
          )
        );


      if (!Array.isArray(cat)) {

        return;

      }


      const updatedList = [

        {
          value: '0',
          label: 'همه محصولات'
        },

        ...cat.map(
          (item) => ({
            value: item.id,
            label: item.text
          })
        )
      ];


      setCategoryList(
        updatedList
      );

    }, 2000);

  }, []);


  useEffect(() => {

    console.log(
      categoryitem
    );

  }, [
    categoryitem
  ]);


  // =========================================================
  // Category
  // =========================================================

  const handleCategoryChange =
    (e) => {

      if (visibleCategory) {

        const selectedId = e;


        const selectedItem =
          categoryList?.find(
            item =>
              item.value == selectedId
          );


        setCategoryItem(
          selectedItem
        );
      }
    };


  const getProductByCategory =
    () => {

      navigate(
        `/categories`
      );

    };


  const sections = [

    {
      title: "ارسال سریع",

      link:
        "/categories?id=27&title=ارسال%20سریع",

      categoryId: {
        value: 27,
        title: "ارسال سریع"
      }
    },

    {
      title: "ایران من",

      link:
        "/categories?id=25&title=ایران%20من",

      categoryId: {
        value: 25,
        title: "ایران من"
      }
    },

    {
      title: "پر فروش ها",

      link:
        "/categories?id=-1&title=پر%20فروش%20ها",

      categoryId: {
        value: -1,
        title: "پر فروش ها"
      }
    },

  ];


  // =========================================================
  // Home slider
  // =========================================================

  const defaultHomeSlides = [

    {
      imageUrl:
        homeslider1,

      imageMobileUrl:
        homeslider1mobile,

      sliderTitle:
        'home-slider-1',

      isLocal: true
    },

    {
      imageUrl:
        homeslider2,

      imageMobileUrl:
        homeslider2mobile,

      sliderTitle:
        'home-slider-2',

      isLocal: true
    },

  ];


  useEffect(() => {

    const fetchHomeSlider =
      async () => {

        try {

          const res =
            await getHomeSliders();


          const sliders =
            res?.data?.data || [];


          setHomeSliders(
            sliders
          );

        } catch (error) {

          console.error(
            'Error fetching home sliders:',
            error
          );

        }
      };


    fetchHomeSlider();

  }, []);


  const slidesToRender =
    homeSliders.length
      ? homeSliders
      : defaultHomeSlides;


  const slides =
    slidesToRender;


  const defaultDelay =
    5000;


  const getSlideImage =
    (slide, key) => {

      if (slide?.isLocal) {

        return slide[key];

      }


      return slide?.[key]
        ? `${imgBaseUrl}${slide[key]}`
        : "";

    };


  const hasMultipleSlides =
    slidesToRender.length > 1;


  // =========================================================
  // Category slider
  // =========================================================

  useEffect(() => {

    const fetchSliderCategories =
      async () => {

        try {

          let res =
            await getCategories();


          if (
            res.data &&
            res.data.data
          ) {

            const filtered =
              res.data.data

                .filter(
                  cat =>
                    cat.showInMainPage
                )

                .sort(
                  (a, b) =>
                    a.sortNumber -
                    b.sortNumber
                )

                .map(
                  cat => ({
                    title:
                      cat.text,

                    link:
                      `/categories?id=${cat.id}&title=${encodeURIComponent(cat.text)}`,

                    categoryId: {
                      value:
                        cat.id,

                      title:
                        cat.text
                    }
                  })
                );


            setSliderCategories(
              filtered
            );
          }

        } catch (error) {

          console.error(
            "Error fetching slider categories:",
            error
          );

        }
      };


    fetchSliderCategories();

  }, []);


  // =========================================================
  // Select
  // =========================================================

  const CustomDropdownIndicator =
    (props) => {

      return (

        <components.DropdownIndicator
          {...props}
        >

          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >

            <path
              d="M17.8527 9.64582C18.0484 9.84073 18.0489 10.1573 17.854 10.3529L12.389 15.8374C12.1741 16.0531 11.8248 16.0531 11.6098 15.8374L6.14484 10.3529C5.94993 10.1573 5.95049 9.84073 6.1461 9.64582C6.34171 9.4509 6.65829 9.45147 6.85321 9.64708L11.9994 14.8117L17.1456 9.64708C17.3406 9.45147 17.6571 9.4509 17.8527 9.64582Z"
              fill="#668CFF"
            />

          </svg>

        </components.DropdownIndicator>
      );
    };


  const customSelectStyles = {

    option: (
      provided
    ) => ({

      ...provided,

      fontSize:
        "14px",

      padding:
        "10px",
    }),


    control: (
      provided
    ) => ({

      ...provided,

      fontSize:
        "14px",
    }),


    singleValue: (
      provided
    ) => ({

      ...provided,

      fontSize:
        "14px",
    }),
  };


  const handleSelectChange =
    (selected) => {

      const selectedId =
        selected.value;


      const selectedItem =
        categoryList?.find(
          item =>
            item.value ==
            selectedId
        );


      setCategoryItem(
        selectedItem
      );


      setCategory(
        selected.value
      );
    };


  function convertToPersianNumbers(
    input
  ) {

    const persianDigits = [
      '۰',
      '۱',
      '۲',
      '۳',
      '۴',
      '۵',
      '۶',
      '۷',
      '۸',
      '۹'
    ];


    return input.replace(
      /\d/g,
      (digit) =>
        persianDigits[digit]
    );
  }


  // =========================================================
  // Render
  // =========================================================

  return (

    <div className='home-container'>

      <Toast ref={toast} />


      <div className="">


        {/* ================= Slider ================= */}

        <div className="row container align-items-center justify-between bg-white rounded-lg mt-3 no-gaps">

          <div className="box sliders-item w-100">

            <Swiper

              dir="rtl"

              modules={[
                Navigation,
                Pagination,
                Autoplay
              ]}

              navigation={
                hasMultipleSlides
              }

              pagination={{
                clickable: true
              }}

              loop={
                hasMultipleSlides
              }

              speed={500}

              className="home-swiper"

              autoplay={{

                delay:
                  (
                    slides[0] &&
                    slides[0].delayTimeSecond
                  )
                    ?
                    slides[0].delayTimeSecond *
                    1000
                    :
                    defaultDelay,

                disableOnInteraction:
                  false,

                pauseOnMouseEnter:
                  true

              }}


              onSwiper={(swiper) => {

                try {

                  const idx =
                    swiper.realIndex ??
                    swiper.activeIndex ??
                    0;


                  const current =
                    slides[idx] ||
                    slides[0];


                  const d =
                    (
                      current &&
                      current.delayTimeSecond
                    )
                      ?
                      current.delayTimeSecond *
                      1000
                      :
                      defaultDelay;


                  swiper.params.autoplay.delay =
                    d;


                  if (
                    swiper.autoplay
                  ) {

                    swiper.autoplay.start();

                  }

                } catch (e) {

                  console.warn(
                    'swiper onSwiper error',
                    e
                  );

                }
              }}


              onSlideChange={(
                swiper
              ) => {

                try {

                  const idx =
                    swiper.realIndex ??
                    swiper.activeIndex ??
                    0;


                  const current =
                    slides[idx] ||
                    slides[0];


                  const d =
                    (
                      current &&
                      current.delayTimeSecond
                    )
                      ?
                      current.delayTimeSecond *
                      1000
                      :
                      defaultDelay;


                  if (
                    swiper.params &&
                    swiper.params.autoplay
                  ) {

                    swiper.params.autoplay.delay =
                      d;


                    if (
                      swiper.autoplay
                    ) {

                      swiper.autoplay.stop();

                      swiper.autoplay.start();

                    }
                  }

                } catch (e) {

                  console.warn(
                    'swiper onSlideChange error',
                    e
                  );

                }
              }}
            >

              {slides.map(
                (
                  slide,
                  index
                ) => {

                  const desktopSrc =
                    getSlideImage(
                      slide,
                      'imageUrl'
                    );


                  const mobileSrc =
                    getSlideImage(
                      slide,
                      'imageMobileUrl'
                    ) ||
                    desktopSrc;


                  const altText =
                    slide.sliderTitle ||
                    slide.adminTitle ||
                    `slider-${index + 1}`;


                  const slideContent = (

                    <picture>

                      {mobileSrc && (

                        <source
                          media="(max-width: 768px)"
                          srcSet={
                            mobileSrc
                          }
                        />

                      )}


                      <img
                        src={
                          desktopSrc ||
                          mobileSrc
                        }
                        alt={
                          altText
                        }
                        className="w-100"
                        style={{
                          margin:
                            '10px 0'
                        }}
                      />

                    </picture>
                  );


                  return (

                    <SwiperSlide
                      key={index}
                    >

                      {
                        slide.link
                          ?

                          (

                            <a
                              href={
                                slide.link
                              }
                              aria-label={
                                altText
                              }
                            >

                              {
                                slideContent
                              }

                            </a>

                          )

                          :

                          slideContent
                      }

                    </SwiperSlide>
                  );
                }
              )}

            </Swiper>

          </div>

        </div>

      </div>


      {/* ================= Top section ================= */}

      <div className="row container flex-top-page-revers align-items-center d-none">

        <div className="col-sm-12 col-md-6 mt-3">

          <div className="text-blue flex align-items-end gap-2 top-web-title">

            <h1 className='font-bold title'>
              کادونا،
            </h1>

            <h3>
              نسل جدید کارتهای بانکی
            </h3>

          </div>


          <ul className='text-li font-bold text-xl mt-3 text-end'>

            <li className='mt-5'>
              امکان استفاده به دفعات تا سقف موجودی کارت
            </li>

            <li className='mt-4'>
              انتخاب طرح دلخواه یا شخصی سازی شده
            </li>

            <li className='mt-4'>

              {
                convertToPersianNumbers(
                  '500 طرح آماده با موضوع و مناسبت های مختلف'
                )
              }

            </li>

          </ul>


          <div className="flex align-items-end gap-4 web">

            <button
              className='btn btn-primary'
              onClick={
                () =>
                  getProductByCategory()
              }
            >

              <img
                src={GiftImg}
                alt=""
              />

              خرید کادونا

            </button>


            <img
              src={ArrowCurve}
              alt=""
            />

          </div>


          <div className="mobile">

            <button
              className='btn btn-primary mx-auto'
              onClick={
                () =>
                  getProductByCategory()
              }
            >

              <img
                src={GiftImg}
                alt=""
              />

              خرید کادونا

            </button>

          </div>

        </div>


        <div className="col-sm-12 col-md-6">

          <div className="text-blue flex align-items-center gap-2 top-mobile-title mt-4">

            <h1 className='title pt-0 font-black'>
              کادونا،
            </h1>

            <h3 className='text-[22px] font-bold'>
              نسل جدید کارتهای بانکی
            </h3>

          </div>


          <div className="img-box">

            <img
              src={BannerImg}
              alt=""
            />

          </div>

        </div>

      </div>


      {/* =====================================================
          Card services
      ===================================================== */}

      <section
        className="container card-services-section my-5"
        dir="rtl"
      >

        {!cardServicesOpen && (

          <button

            type="button"

            className="card-services-mobile-trigger"

            onClick={
              () =>
                setCardServicesOpen(
                  true
                )
            }
          >

            <span className="card-services-trigger-icon">

              <img
                src={Phone}
                alt=""
              />

            </span>


            <span className="card-services-trigger-copy">

              <strong>
                خدمات هوشمند کارت
              </strong>

            </span>


            <span
              className="card-services-trigger-arrow"
              aria-hidden="true"
            >

              ‹

            </span>

          </button>
        )}


        <div
          className={
            `card-services-layout ${
              cardServicesOpen
                ?
                'is-mobile-open'
                :
                ''
            }`
          }
        >

          <div className="card-services-form-card">

            <button

              type="button"

              className="card-services-mobile-back"

              onClick={
                () =>
                  setCardServicesOpen(
                    false
                  )
              }

              aria-label="بازگشت"
            >

              ›

            </button>


            <h3>
              ورود شماره کارت
            </h3>


            <p>
              شماره کارت ۱۶ رقمی خود را وارد کنید
            </p>


            <div
              className="card-number-fields"
              dir="ltr"
            >

              <input

                type="text"

                inputMode="numeric"

                value={
                  CARD_PREFIX_1
                }

                readOnly

                aria-label="چهار رقم اول شماره کارت"

              />


              <span className="card-number-separator">
                -
              </span>


              <input

                type="text"

                inputMode="numeric"

                value={
                  CARD_PREFIX_2
                }

                readOnly

                aria-label="چهار رقم دوم شماره کارت"

              />


              <span className="card-number-separator">
                -
              </span>


              <input

                ref={
                  cardPart3Ref
                }

                type="text"

                inputMode="numeric"

                autoComplete="off"

                maxLength={4}

                value={
                  cardPart3
                }

                onChange={
                  (e) =>
                    handleCardPartChange(
                      e.target.value,
                      setCardPart3,
                      cardPart4Ref
                    )
                }

                placeholder="0000"

                aria-label="چهار رقم سوم شماره کارت"

              />


              <span className="card-number-separator">
                -
              </span>


              <input

                ref={
                  cardPart4Ref
                }

                type="text"

                inputMode="numeric"

                autoComplete="off"

                maxLength={4}

                value={
                  cardPart4
                }

                onChange={
                  (e) =>
                    handleCardPartChange(
                      e.target.value,
                      setCardPart4
                    )
                }

                onKeyDown={
                  (e) => {

                    if (
                      e.key ===
                        'Backspace' &&
                      !cardPart4
                    ) {

                      cardPart3Ref.current
                        ?.focus();

                    }
                  }
                }

                placeholder="0000"

                aria-label="چهار رقم چهارم شماره کارت"

              />

            </div>


            {/* QR Button */}

            <button

              type="button"

              className="card-qr-scan-button"

              onClick={() => {

                qrScanResolvedRef.current =
                  false;

                lastQrTextRef.current =
                  '';

                setQrScannerOpen(
                  true
                );

              }}

              aria-label="اسکن رمزینه (QR-Code) با دوربین"
            >

              <span
                className="card-qr-scan-icon"
                aria-hidden="true"
              >

                <svg
                  viewBox="0 0 24 24"
                  role="img"
                >

                  <path
                    d="M4 4h6v2H6v4H4V4Zm10 0h6v6h-2V6h-4V4ZM4 14h2v4h4v2H4v-6Zm14 0h2v6h-6v-2h4v-4ZM8 8h3v3H8V8Zm5 0h3v3h-3V8Zm-5 5h3v3H8v-3Zm5 0h1.5v1.5H16V13h2v5h-5v-2h1.5v-1.5H13V13Z"
                  />

                </svg>

              </span>


              <span>
                اسکن رمزینه (QR-Code) کارت
              </span>

            </button>


            <button

              type="button"

              className="card-services-submit"

              disabled={
                !isCardNumberComplete
              }

              onClick={
                goToCardServices
              }
            >

              ورود به صفحه خدمات هوشمند کارت

              <span
                aria-hidden="true"
              >
                ←
              </span>

            </button>

          </div>

        </div>


        {/* =====================================================
            QR Modal
        ===================================================== */}

        {qrScannerOpen && (

          <div

            className="card-qr-scanner-modal"

            role="dialog"

            aria-modal="true"

            aria-label="اسکن رمزینه (QR-Code) کارت"
          >

            <div className="card-qr-scanner-panel">


              <button

                type="button"

                className="card-qr-scanner-close"

                onClick={
                  closeQrScanner
                }

                aria-label="بستن اسکنر"
              >

                ×

              </button>


              <h4>
                اسکن رمزینه (QR-Code) کارت
              </h4>


              <p>
                رمزینه (QR-Code) را داخل کادر دوربین قرار دهید.
              </p>


              <div className="card-qr-video-wrap">

                <div
                  id="card-qr-reader"
                  className="card-qr-reader"
                />


                {qrScannerStarting && (

                  <span className="card-qr-loading">

                    در حال فعال‌کردن دوربین…

                  </span>

                )}

              </div>

            </div>

          </div>

        )}

      </section>


      {/* =====================================================
          Category products
      ===================================================== */}

      {sliderCategories.map(
        (
          section,
          index
        ) => (

          <section
            className="slider-box"
            key={index}
          >

            <div className='container flex align-items-center flex-col-dir justify-content-center gap-4'>

              <div className="w-100 p-2 box sliders-item">

                <div className='row p-3'>

                  <span className='biggerfont col-md-2 text-blue font-bold'>

                    {
                      section.title
                    }

                  </span>


                  <div className='col-md-8' />


                  <div className='col-md-2'>

                    <a

                      style={{
                        float: 'left',
                        fontSize:
                          '14px'
                      }}

                      href={
                        section.link
                      }

                      className='nav-link pull-left text-blue font-bold'
                    >

                      مشاهده همه

                    </a>

                  </div>

                </div>


                <ProductItems
                  categoryId={
                    section.categoryId
                  }
                />

              </div>

            </div>

          </section>

        )
      )}


      {/* =====================================================
          Category icons
      ===================================================== */}

      <section
        style={{
          position:
            'relative'
        }}
      >

        <div

          className='web'

          style={{
            position:
              'absolute',

            width:
              '100vw',

            height:
              '2px',

            backgroundColor:
              '#fff',

            top:
              '40%',

            zIndex:
              '-1'
          }}

        />


        <img

          src={
            ThreeDots
          }

          className='dots-slider mobile'

          alt=""

          style={{
            position:
              'absolute',

            left:
              '0',

            top:
              '0.5em',

            zIndex:
              '-2'
          }}

        />


        <div className="flex justify-center mt-10 category-icon-list">


          <div

            className="item p-3 flex flex-col align-items-center justify-center gap-1"

            onClick={() => {

              window.location.href =
                'https://hobyna.ir/v/2aidru';

            }}
          >

            <div className="rounded-lg border-1 border-blue p-2 icon-box bg-white">

              <img
                className='icon-clip'
                src={buy}
                alt=""
              />

            </div>


            <h6 className="text-blue font-bold">

              خرید کادونا

            </h6>

          </div>


          <div

            className="item p-3 flex flex-col align-items-center justify-center gap-1"

            onClick={() => {

              window.location.href =
                'https://hobyna.ir/v/dKtvFV';

            }}
          >

            <div className="rounded-lg border-1 border-blue p-2 bg-white icon-box">

              <img
                className='icon-clip'
                src={charge}
                alt=""
              />

            </div>


            <h6 className="text-blue font-bold">

              آموزش خرید و شارژ

            </h6>

          </div>


          <div

            className="item p-3 flex flex-col align-items-center justify-center gap-1"

            onClick={() => {

              window.location.href =
                'https://hobyna.ir/v/pxkvcf';

            }}
          >

            <div className="rounded-lg border-1 border-blue p-2 bg-white icon-box">

              <img
                className='icon-clip'
                src={orgPack}
                alt=""
              />

            </div>


            <h6 className="text-blue font-bold">

              خرید سازمانی

            </h6>

          </div>


          <div

            className="item p-3 flex flex-col align-items-center justify-center gap-1"

            onClick={() => {

              window.location.href =
                `/design`;

            }}
          >

            <div className="rounded-lg border-1 border-blue p-2 bg-white icon-box">

              <img
                src={Special}
                alt=""
              />

            </div>


            <h6 className="text-blue font-bold">

              طرح دلخواه

            </h6>

          </div>


          <div

            className="item p-3 flex flex-col align-items-center justify-center gap-1"

            onClick={() => {

              window.location.href =
                `/categories`;

            }}
          >

            <div className="rounded-lg border-1 border-blue p-2 bg-white icon-box">

              <img
                src={Ect}
                alt=""
              />

            </div>


            <h6 className="text-blue font-bold">

              دسته بندی ها

            </h6>

          </div>

        </div>

      </section>


      {/* =====================================================
          What is Kadona
      ===================================================== */}

      <section className='mt-10'>

        <h2 className='font-bold text-blue text-center'>

          کادونا چیست؟

        </h2>


        <div className="container bg-dots">

          <div className="features row gy-4 mt-4 mx-auto">


            <div className="col-md-3 col-lg-3 col-6">

              <div className='item gradient-border aspect-square bg-white rounded-2xl'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={Picture}
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      دسترسی به مجموعه متنوعی از طرح های آماده
                    </span>

                  </div>

                </div>

              </div>

            </div>


            <div className="col-md-3 col-lg-3 col-6">

              <div className='item gradient-border aspect-square bg-white rounded-2xl'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={
                        ShoppingCart
                      }
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      اتصال به شبکه شتاب و امکان خرید از تمامی درگاه‌های بانکی
                    </span>

                  </div>

                </div>

              </div>

            </div>


            <div className="col-md-3 col-lg-3 col-6">

              <div className='item gradient-border aspect-square bg-white rounded-2xl'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={
                        CashlessPayment
                      }
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      قابلیت شارژ تا سقف پنجاه میلیون ریال
                    </span>

                  </div>

                </div>

              </div>

            </div>


            <div className="col-md-3 col-lg-3 col-6">

              <div className='item gradient-border aspect-square bg-white rounded-2xl'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={
                        Illustration
                      }
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      طراحی دلخواه و خرید آنلاین
                    </span>

                  </div>

                </div>

              </div>

            </div>


            <div className="col-md-3 col-lg-3 col-6">

              <div className='item gradient-border aspect-square bg-white rounded-2xl'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={
                        OfficeBuilding
                      }
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      طرف قرارداد با سازمان‌های خصوصی و دولتی
                    </span>

                  </div>

                </div>

              </div>

            </div>


            <div className="col-md-3 col-lg-3 col-6">

              <div className='item gradient-border aspect-square bg-white rounded-2xl'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={
                        Acceptance
                      }
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      دارای مجوز از مرکز توسعه تجارت الکترونیک
                    </span>

                  </div>

                </div>

              </div>

            </div>


            <div className="col-md-3 col-lg-3 col-6">

              <div className='item gradient-border aspect-square bg-white rounded-2xl'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={
                        Deadline
                      }
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      قابل تهیه از فروشگاه‌های منتخب حتی ایام تعطیل
                    </span>

                  </div>

                </div>

              </div>

            </div>


            <div className="col-md-3 col-lg-3 col-6">

              <div className='gradient-border aspect-square bg-white rounded-2xl item'>

                <div className="flex flex-col justify-center align-items-center gap-2">

                  <div>

                    <img
                      src={
                        Technical
                      }
                      alt=""
                    />

                  </div>


                  <div className='text-center text-sm font-bold'>

                    <span>
                      مرکز پشتیبانی آنلاین و تلفنی
                    </span>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          Partners
      ===================================================== */}

      <h4

        className="text-blue font-black mobile text-center mt-4"

        style={{
          marginBottom:
            '-1em',

          fontSize:
            '24px'
        }}
      >

        شرکای تجاری کادونا

      </h4>


      <div

        className="row container flex-col-dir customer-lists align-items-center justify-between px-4 py-3 bg-white rounded-lg mt-5"

        style={{
          marginBottom:
            '-3.5em',

          position:
            'relative',

          zIndex:
            '1'
        }}
      >

        <div className='col-md-6 col-sm-12'>

          <h4 className="text-blue font-bold web">

            شرکای تجاری کادونا

          </h4>

        </div>


        <div className='flex-1 col-md-6 col-sm-12'>

          <CustomerComponent />

        </div>

      </div>


      {/* =====================================================
          Design editor
      ===================================================== */}

      <div

        className="bg-[#E5ECFF]"

        style={{
          position:
            'relative',

          paddingTop:
            '6em',

          paddingBottom:
            '6em'
        }}
      >

        <img

          src={
            SDots
          }

          alt=""

          className='web'

          style={{
            position:
              'absolute',

            right:
              '1em',

            bottom:
              '3.5em'
          }}

        />


        <div className="container px-0">

          <DesignEditor />

        </div>

      </div>


      {/* =====================================================
          Buy now
      ===================================================== */}

      <div

        className='d-flex align-items-center justify-content-between bg-white p-4 container rounded-lg'

        style={{
          marginTop:
            '-3em',

          position:
            'relative'
        }}
      >

        <h6 className='text-[#001966] font-bold text-2xl'>

          همین الان خرید کن ...

        </h6>


        <button

          className='btn btn-primary d-flex align-items-center gap-2'

          type='button'

          onClick={() => {

            window.location.href =
              '/categories';

          }}
        >

          <img
            src={
              Basket
            }
            alt=""
          />

          خرید کادونا

        </button>

      </div>


      {/* =====================================================
          FAQ
      ===================================================== */}

      <div

        className="container p-0 max-sm:!p-1"

        style={{
          marginBottom:
            '6em'
        }}
      >

        <h2 className='text-blue d-flex font-bold text-end mt-5 title'>

          سوالات متداول

        </h2>


        <FaqAccordion />

      </div>


      {/* =====================================================
          Footer
      ===================================================== */}

      <div className="home-footer mt-40">

        <Footer />

      </div>

    </div>
  );
}


export default Home;